import { IStringContext, defaultValues } from "./StringContext";

import { Culture, Env } from "@bn-monorepo/js-packages";
import React from "react";
import { RegionId } from "./contract/RegionId";

export interface KindlySettings {
  kindleyKey: string;
  kindleyActivePathList: string[];
}
export interface ProductSlug {
  creditCard: string;
  loan: string;
  savingsAccount: string;
  insurance: string;
}

export interface SettingsInterface {
  env?: Env;
  useCloudinary: boolean;
  mediaUrl: string;
  resolveUrl: (umbracoUrl: string) => string;
  refreshSettings: () => void;
  cookieConsentEnabled: boolean;
  disableCookieConsentForMarketingAndPersonalisation: boolean;
  cookieConsentHasConsented: boolean;
  cookieConsentWantsAnalysis: boolean;
  cookieConsentWantsMarketing: boolean;
  cookieConsentWantsPersonalization: boolean;
  localization: IStringContext;
  serverRootPath: string;
  apiBaseUrl: string;
  kindleySettings: null | KindlySettings;
  showNobaAssistant: boolean;
  showNobaAssistantDevTools: boolean;
  region: RegionId;
  hostName: string;
  isApp: boolean;
  isAuthenticated: boolean;
  utmCookie: any;
  locale: Culture;
  hideLogin: boolean;
  personId: string;
  productSlug: ProductSlug;
  allowDarkMode: boolean;
}

export const SettingsContext = React.createContext<SettingsInterface>({
  useCloudinary: true,
  mediaUrl: "",
  resolveUrl: () => "",
  refreshSettings: () => {},
  cookieConsentEnabled: false,
  disableCookieConsentForMarketingAndPersonalisation: false,
  cookieConsentHasConsented: false,
  cookieConsentWantsAnalysis: false,
  cookieConsentWantsMarketing: false,
  cookieConsentWantsPersonalization: false,
  localization: defaultValues,
  serverRootPath: "",
  apiBaseUrl: "",
  utmCookie: {},
  kindleySettings: null,
  showNobaAssistant: false,
  showNobaAssistantDevTools: false,
  region: RegionId ? RegionId.None : 0,
  hostName: "",
  isApp: false,
  isAuthenticated: false,
  locale: "nb-NO",
  hideLogin: false,
  personId: "",
  productSlug: {
    creditCard: "",
    insurance: "",
    loan: "",
    savingsAccount: "",
  },
  allowDarkMode: false,
});
